import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextField } from '@rmwc/textfield';
import { Button } from '@rmwc/button';

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Feedback = styled.div`
  margin: 20px 0;
  text-align: center;
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.error};
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
`;

const SubmitButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  padding: 10px 0;
`;

const FormOneTimePassword = props => {
  const { username, password, onSubmit, feedback } = props;
  const [errors, setErrors] = useState(null);

  const validateData = ({ newPassword, newPasswordConfirm }) => {
    if (newPassword !== newPasswordConfirm) {
      const errorMessage = 'Las contraseñas no coinciden.';
      setErrors({ newPassword: errorMessage, newPasswordConfirm: errorMessage });
      return false;
    }
    setErrors(null);
    return true;
  };

  const handleSubmit = event => {
    event.preventDefault();
    const { newPassword, newPasswordConfirm } = event.target.elements;
    const data = {
      newPassword: newPassword.value,
      newPasswordConfirm: newPasswordConfirm.value,
    };
    const isValidData = validateData(data);
    if (isValidData) {
      onSubmit({ username, password, newPassword: data.newPassword });
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Feedback>{feedback}</Feedback>
      <Field>
        <TextField disabled type="text" name="username" label="Usuario" value={username} />
      </Field>
      <Field>
        <TextField disabled type="password" name="password" label="Contraseña" value={password} />
      </Field>
      <Field>
        <TextField
          required
          type="password"
          name="newPassword"
          label="Contraseña nueva"
          invalid={errors?.newPassword}
          helpText={{ validationMsg: true, children: errors?.newPassword }}
        />
      </Field>
      <Field>
        <TextField
          required
          type="password"
          name="newPasswordConfirm"
          label="Repetir contraseña nueva"
          invalid={errors?.newPasswordConfirm}
          helpText={{ validationMsg: true, children: errors?.newPasswordConfirm }}
        />
      </Field>
      <SubmitButton>
        <Button label="Entrar" raised />
      </SubmitButton>
    </Form>
  );
};

FormOneTimePassword.propTypes = {
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  feedback: PropTypes.string,
};

FormOneTimePassword.defaultProps = {
  feedback: '',
};

export default FormOneTimePassword;
